import React, {useEffect, useMemo, useState} from 'react'
import {KTSVG, useDebounce} from '../../../../_metronic/helpers'
import {Link, useNavigate} from 'react-router-dom'
import {
  useDeleteFileSchedulerMutation,
  useDeleteSchedulerMutation,
  useGetSchedulerFileQuery,
  useLazyGetSchedulerHistoryQuery,
  useLazyGetSchedulerLogQuery,
  usePauseSchedulerMutation,
} from '../../../../services/cellcast'
import ReactPaginate from 'react-paginate'
import moment from 'moment-timezone'
import NodataYet from '../../../Components/NodataYet'
import {Dropdown, DropdownButton, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import {toast} from 'react-toastify'
import {RoutePaths} from '../../../routing/RoutePath'
import {checkIsScheduled, ScheduleStatus} from '../reports-analytics/Common'
import clsx from 'clsx'

const FileScheduler = () => {
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(10)
  const [open, setOpen] = useState(false)
  const [openFileScheduler, setOpenFileScheduler] = useState(false)
  const [selectedDeleted, setSelectedDeleted] = useState('')
  const [search, setSearch] = useState('')
  const debouncedSearchTerm = useDebounce(search, 500)

  const {isFetching, data, refetch} = useGetSchedulerFileQuery({
    sortField: 'createdAt',
    page: page,
    size,
    sortOrder: 'descend',
    search: debouncedSearchTerm,
  })

  const [deleteScheduler, {isLoading}] = useDeleteSchedulerMutation()
  const [pauseScheduler, {isLoading: isLoadingPauseScheduler}] = usePauseSchedulerMutation()
  const [getSchedulerHistory, {data: scheduleHistorys, isLoading: isLoadingScheduleHistory}] =
    useLazyGetSchedulerHistoryQuery()
  const [getSchedulerLog, {data: scheduleLogs, isLoading: isLoadingScheduleLog}] =
    useLazyGetSchedulerLogQuery()

  const [deleteFileScheduler] = useDeleteFileSchedulerMutation()

  const navigate = useNavigate()
  const [selectedFileScheduler, setSelectedFileScheduler] = useState('')
  const selectedScheduler = data?.items?.find((it: any) => it._id === selectedFileScheduler)

  // FUNCTION

  // refetch when change pages
  useEffect(() => {
    refetch()
  }, [page, size])

  const pauseSchedulerHandler = async (id: any) => {
    pauseScheduler({id})
      .unwrap()
      .then((res) => {
        toast.success('success')
        refetch()
      })
      .catch((e) => toast.error(e?.data?.message))
  }

  const historySchedulerHandler = async (id: any) => {
    getSchedulerHistory({id})
      .unwrap()
      .then((res) => toast.success('success'))
      .catch((e) => toast.error(e?.data?.message))
  }

  // MODALS
  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete schedule?'}
        confirm={() => {
          deleteScheduler({id: selectedDeleted})
            .unwrap()
            .then((res) => {
              refetch()
              toast.success('success')
            })
            .catch((e) => {
              toast.error(e?.data?.message)
            })
        }}
      />
    ),
    [open, deleteScheduler, refetch, selectedDeleted]
  )

  const fileSchedulerDeleteConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={openFileScheduler}
        handleClose={() => setOpenFileScheduler(false)}
        Message={'Are you sure, you want to delete this file schedule?'}
        confirm={() => {
          deleteFileScheduler({id: selectedScheduler?._id})
            .unwrap()
            .then((res) => {
              refetch()
              toast.success('success')
              setSelectedFileScheduler('')
            })
            .catch((e) => {
              toast.error(e?.data?.message)
            })
        }}
      />
    ),
    [openFileScheduler, deleteFileScheduler, refetch, selectedScheduler]
  )

  return (
    <>
      {fileSchedulerDeleteConfirmation}
      {confirmation}
      <div className='card p-8'>
        <div className='row'>
          {/* <!-- Sidebar --> */}
          <div className='col-md-4'>
            <div className='d-flex mb-2'>
              <div className='form-group flex-grow-1'>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search...'
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <Link
                className='btn btn-disable btn-icon btn-bg-light btn-primary ms-2'
                to='/file-scheduler/form'
              >
                <i className='bi bi-plus-circle'></i>
              </Link>
            </div>
            <div className='list-group'>
              {data?.items.map((it: any) => (
                <div
                  className='list-group-item list-group-item-action p-4'
                  onClick={() => setSelectedFileScheduler(it?._id)}
                >
                  {it.name} <br />
                  <small className='text-muted'>Sender: {it.sender}</small>
                </div>
              ))}
            </div>

            {data?.total > 0 ? (
              <div className='abcd'>
                <select
                  onChange={async (e: any) => {
                    setSize(e.target.value)
                    setPage(1)
                  }}
                  value={size}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>

                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={data?.totalPages}
                  onPageChange={async (e: any) => {
                    setPage(e.selected + 1)
                  }}
                  containerClassName={'pagination'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            ) : isFetching ? (
              <div className='d-flex justify-content-center'>
                <Spinner />
              </div>
            ) : (
              <NodataYet message='No recent file scheduler sms messages (yet!)' />
            )}
          </div>

          {/* <!-- Main content --> */}

          {selectedFileScheduler && (
            <div className='col-md-8'>
              <div className='card'>
                <div className='card-body'>
                  <h5 className='card-title'>{selectedScheduler?.name}</h5>
                  <p className='card-text'>
                    <strong>Description:</strong> {selectedScheduler?.description}
                  </p>
                  <p className='card-text'>
                    <strong>Sender:</strong> {selectedScheduler?.sender}
                  </p>
                  {/* <p className='card-text'>
                    <strong>Spreadsheet URL:</strong>
                  </p> */}
                  <p className='card-text'>
                    <strong>TimeZone:</strong> {selectedScheduler?.timezone}
                  </p>
                  <div
                    className='btn btn-primary btn-sm'
                    onClick={() => navigate('/report-analytics/scheduler-messages')}
                  >
                    View Log
                  </div>
                  <div
                    className='btn btn-secondary ms-2 btn-sm'
                    onClick={() => navigate('/file-scheduler/form')}
                  >
                    Run SMS Campaign
                  </div>
                  <div
                    className='btn btn-danger ms-2 btn-sm'
                    onClick={() => {
                      setOpenFileScheduler(true)
                    }}
                  >
                    Delete File Scheduler
                  </div>
                  {/* <div className='table-responsive'> */}
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th>Receiver</th>
                        <th>Message</th>
                        <th>Type</th>
                        <th>Next Execution</th>
                        <th>Status</th>
                        <th>History</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedScheduler?.schedules.map((it: any) => {
                        const scheduleStatus = checkIsScheduled({
                          status: it?.status,
                          nextExecution: it?.nextExecution,
                          active: it?.active,
                          messageStatus: it?.messageStatus,
                        })

                        const badgeClass = clsx({
                          'badge badge-light-success fw-bold': [ScheduleStatus.COMPLETED].includes(
                            scheduleStatus
                          ),
                          'badge badge-light-danger fw-bold': [
                            ScheduleStatus.CANCELLED,
                            ScheduleStatus.FAILED,
                          ].includes(scheduleStatus),
                          'badge badge-light-warning fw-bold': [ScheduleStatus.SCHEDULED].includes(
                            scheduleStatus
                          ),
                          'badge badge-light-info fw-bold': [ScheduleStatus.PAUSED].includes(
                            scheduleStatus
                          ),
                        })

                        return (
                          <tr className='border-dashed border-2 border-bottom'>
                            <td>{it.receiver}</td>
                            <td>{it.message}</td>
                            <td>{it.type}</td>
                            <td>
                              {moment(it.nextExecution)
                                .tz(selectedScheduler.timezone)
                                .format('l LT')}
                            </td>
                            <td>
                              <span className={badgeClass}>{scheduleStatus?.toUpperCase()}</span>
                            </td>
                            <td>
                              <button
                                className='btn btn-sm btn-secondary btn-icon'
                                onClick={() => navigate('/report-analytics/scheduler-messages')}
                              >
                                <i className='bi bi-clock-history'></i>
                              </button>
                            </td>
                            <td>
                              <div className='d-grid gap-3'>
                                <DropdownButton
                                  title={<i className='bi bi-three-dots fs-5'></i>}
                                  id='dropdown-menu-align-right'
                                  className='inbox-dropdown'
                                  variant='outline-info'
                                >
                                  <Dropdown.Item
                                    className='menu-item p-3'
                                    onClick={() => {
                                      navigate(RoutePaths.schedulerDetail.replace(':id', it?._id))
                                    }}
                                  >
                                    Detail
                                  </Dropdown.Item>

                                  {![
                                    ScheduleStatus.COMPLETED,
                                    ScheduleStatus.CANCELLED,
                                    ScheduleStatus.FAILED,
                                  ].includes(scheduleStatus) && (
                                    <Dropdown.Item
                                      className='menu-item p-3'
                                      onClick={() => {
                                        setOpen(true)
                                        setSelectedDeleted(it?._id)
                                      }}
                                    >
                                      Delete
                                    </Dropdown.Item>
                                  )}
                                </DropdownButton>
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  {/* </div> */}

                  {/* TODO: add pagination later */}
                  {/* <div className='abcd'>
                  <select onChange={(e: any) => {}} value={10}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>

                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={0}
                    pageClassName="page-item-none"
                    breakClassName="page-item-none"
                    onPageChange={(e: any) => {}}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default FileScheduler
